// Размеры модели текстиля
export default {
  state: {
    textile: {
      '4xs': { id: '4xs' },
      '3xs': { id: '3xs' },
      '2xs': { id: '2xs' },
      'xs': { id: 'xs' },
      's': { id: 's' },
      'm': { id: 'm' },
      'l': { id: 'l' },
      'xl': { id: 'xl' },
      '2xl': { id: '2xl' },
      '3xl': { id: '3xl' },
      '4xl': { id: '4xl' },
      '5xl': { id: '5xl' },
    },
    bags: {
      bag20x30: {
        id: 'bag20x30',
        label: '20×30 см',
        priceIncrease: 0,
      },
      bag30x40: {
        id: 'bag30x40',
        label: '30×40 см',
        priceIncrease: 0,
      },
      bag40x50: {
        id: 'bag40x50',
        label: '40×50 см',
        priceIncrease: 0,
      },
      bag50x60: {
        id: 'bag50x60',
        label: '50×60 см',
        priceIncrease: 3,
      },
      bag60x70: {
        id: 'bag60x70',
        label: '60×70 см',
        priceIncrease: 9,
      },
    },
  },
}